import React from 'react';

import { ExternalLink } from '@rover/icons';
import { Box, Flex, Heading, Paragraph } from '@rover/kibble/core';
import BottomSheet from '@rover/kibble/official-patterns/BottomSheet';
import Modal from '@rover/kibble/official-patterns/Modal';
import { MQ } from '@rover/kibble/styles';
import { BhCtaButton } from '@rover/pages/src/bright-horizons/HubPage/common/BhCtaButton';
import useMatchMedia from '@rover/react-lib/src/hooks/useMatchMedia';
import { useApiBrightHorizonsCreditInactivityRetrieve } from '@rover/rsdk/src/apiClient/latest/api-bright-horizons-credit-inactivity-retrieve';
import type { OpenCreditInactivityModalAction } from '@rover/rsdk/src/apiClient/latest/model';
import useIsBHUserShim from '@rover/shared/js/hooks/useIsBHUserShim';

const ExitBrightHorizonsPartnershipModal: React.FC = () => {
  const isMobile = useMatchMedia(MQ.MOBILE.getBreakpointString());
  const isBHUser = useIsBHUserShim();
  const { data: inactivityData } = useApiBrightHorizonsCreditInactivityRetrieve({
    query: { enabled: isBHUser },
  });
  if (!inactivityData) return null;

  const modalContent = (
    <Box padding="1x">
      <Heading size="300">
        {(inactivityData?.inactivityModal as OpenCreditInactivityModalAction)?.title}
      </Heading>
      <Paragraph mb="8x">
        {(inactivityData?.inactivityModal as OpenCreditInactivityModalAction)?.content}
      </Paragraph>
      <BhCtaButton
        cta={(inactivityData?.inactivityModal as OpenCreditInactivityModalAction)?.primaryButton}
        fullWidth
        size="small"
        mb="3x"
      />
      <BhCtaButton
        cta={(inactivityData?.inactivityModal as OpenCreditInactivityModalAction)?.secondaryButton}
        fullWidth
        size="small"
        icon={ExternalLink}
        webProps={{ hrefTarget: '_blank' }}
        iconAlignment="right"
      />
    </Box>
  );

  return (
    <Flex>
      {isMobile ? (
        <BottomSheet
          height={325} // required for native
          isOpen={inactivityData.isInactive}
          onRequestClose={() => {}}
          isDismissible
          closeOnDragDown
          hideCloseIcon
        >
          {modalContent}
        </BottomSheet>
      ) : (
        <Modal isOpen={inactivityData.isInactive} onRequestClose={() => {}} headerSize="300">
          {modalContent}
        </Modal>
      )}
    </Flex>
  );
};

export default ExitBrightHorizonsPartnershipModal;
